export default __webpack_public_path__ + "static/media/kazam 3.3.5291c22a.png";